import {
  convertJSONToArray,
  createElement,
  getItemLocalStorage,
  objectLength,
  select,
  setItemLocalStorage,
  scoreNumberHtmlElement,
  scoreNumberHtmlElementNew,
} from "@utils/function";

const yards = convertJSONToArray(HQ.Properties.holes);
const yardsArray = convertJSONToArray(yards[0]);

document.addEventListener("click", (e) => {
  const target = e.target;

  if (
    target.classList.contains("player-scoring") ||
    target.classList.contains("player-favorites")
  ) {
    const parent = target.parentNode;
    const nextElementSibling = parent.nextElementSibling;
    const playerId = parent.dataset.id;
    const activePlayer = parent.classList.contains("active-player-scoring");

    // console.log("activePlayer", activePlayer);

    const choiceLocalStorage = target.classList.contains("player-scoring")
      ? "HQshowScoringPlayer"
      : "HQshowFavoritesPlayer";

    const getLocalStorage = getItemLocalStorage(choiceLocalStorage);

    let playersScoring = [];

    const checkTabel = target.closest(".table-players");

    const typeOfTabel = checkTabel ? "players" : "favorites";

    if (!activePlayer) {
      FindPlayerData(+playerId, typeOfTabel);

      if (getLocalStorage) {
        playersScoring.push(...new Set(getLocalStorage));
      }

      playersScoring.push(+playerId);

      const newPlayers = [...new Set(playersScoring)];
      setItemLocalStorage(choiceLocalStorage, newPlayers);
    } else if (nextElementSibling.classList.contains("d-none")) {
      nextElementSibling.classList.remove("d-none");
    } else {
      nextElementSibling.classList.add("d-none");
      // console.log(+playerId);

      parent.classList.remove("active-player-scoring");

      const filtered = getLocalStorage.filter((value) => value !== +playerId);
      setItemLocalStorage(choiceLocalStorage, filtered);
    }
  }
});

/**
 * Find player data and create scoring table
 *
 * @param {number} id
 * @param {string} typeOfTable
 */
function FindPlayerData(id, typeOfTable) {
  // console.log("typeOfTable", typeOfTable);
  // const scoreRow = select(`#player-${id}`);

  const scoreRow = select(`#player-${typeOfTable}-${id}`);

  if (scoreRow) {
    scoreRow.remove();
  }

  const checkIfGetAllPlayersIsArray = Array.isArray(
    HQ.Properties.getAllPlayers
  );
  const hqGetAllPlayers = checkIfGetAllPlayersIsArray
    ? HQ.Properties.getAllPlayers
    : convertJSONToArray(HQ.Properties.getAllPlayers);

  const playerRow = select(
    `.table-${typeOfTable} > tbody > tr[data-id="${id}"]`
  );

  // console.log("playerRow", playerRow);

  hqGetAllPlayers.map((player) => {
    // console.log(player);
    if (id === player.id) {
      // console.log(id, player.id);
      // buildScoringTable(player);
      // console.log("id", id);

      playerRow?.classList.toggle("active-player-scoring");
      playerRow?.insertAdjacentElement(
        "afterend",
        BuildScoringTable(player, typeOfTable)
      );
    }
  });
}

/**
 * Create scoring table for player
 *
 * @param {object} player
 * @param {string} typeOfTable
 * @returns HTMLElement
 */
function BuildScoringTable(player, typeOfTable) {
  const rounds = player?.rounds;
  const dataId = player?.id;

  if (typeof rounds === "undefined") return;

  // const checkPlayerId = document.querySelector("#player-39");
  // if (checkPlayerId) return;

  const columns = 22;

  // create next tr

  const rowGlobal = createElement("tr");
  rowGlobal.classList.add("player-scoring");
  rowGlobal.setAttribute("id", `player-${typeOfTable}-${dataId}`);
  const rowTd = createElement("td");
  rowTd.classList.add("player-scoring-td");
  rowTd.colSpan = 100;

  rowGlobal.appendChild(rowTd);

  // create table
  const table = createElement("table");
  table.classList.add("table");
  table.classList.add("scoring-table");
  // table.classList.add("table-responsive");

  // add table to row global
  rowTd.appendChild(table);

  // create table header
  const tableHeaderHole = createElement("tr");
  tableHeaderHole.classList.add("table-head-scroing");
  tableHeaderHole.setAttribute(
    "style",
    "background-color: var(--main-color-bg) !important"
  );
  // tableHeader.classList.add("d-flex");
  // tableHeader.classList.add("row");
  table.appendChild(tableHeaderHole);

  // create table header row
  const tableBody = createElement("tbody");
  tableBody.classList.add("scoring-table-body");
  tableBody.classList.add("row-cols-21");
  // tableBody.classList.add("row");
  table.appendChild(tableBody);

  // add tfoot body

  // table.insertAdjacentHTML("beforeend", legendForLeaderBoard);

  // create table header cells
  for (let i = 0; i < columns; i++) {
    const tableHeaderCellHole = createElement("td");
    // tableHeaderCell.classList.add("col");
    // tableHeaderCellHole.classList.add("text-center");
    if (i === 0) {
      tableHeaderCellHole.textContent = "Hole";
    } else if (i === 10) {
      tableHeaderCellHole.textContent = "OUT";
    } else if (i === 20) {
      tableHeaderCellHole.textContent = "IN";
    } else if (i === 21) {
      tableHeaderCellHole.textContent = "TOT";
    } else {
      tableHeaderCellHole.textContent = i > 10 ? i - 1 : i;
    }

    // add table header cell to table header row
    tableHeaderHole.appendChild(tableHeaderCellHole);
  }

  const tableHeaderYards = createElement("tr");
  tableHeaderYards.classList.add("table-head-scroing");
  tableHeaderYards.classList.add("row-yards");
  tableHeaderYards.setAttribute(
    "style",
    "background-color: var(--main-color-bg) !important"
  );

  tableBody.insertAdjacentElement("beforebegin", tableHeaderYards);

  for (let y = 0; y < columns; y++) {
    const tableHeaderCellYds = createElement("td");
    // tableHeaderCellYds.classList.add("text-center");

    if (y === 0) {
      tableHeaderCellYds.textContent = "Yds";
    } else if (y === 10) {
      const sumYards = sumYardsAndPar(yardsArray, "yds", "out");
      tableHeaderCellYds.textContent = sumYards === 0 ? "-" : sumYards;
    } else if (y === 20) {
      const sumYards = sumYardsAndPar(yardsArray, "yds", "in");
      tableHeaderCellYds.textContent = sumYards === 0 ? "-" : sumYards;
    } else if (y === 21) {
      const sumYards = sumYardsAndPar(yardsArray, "yds", "tot");
      tableHeaderCellYds.textContent = sumYards === 0 ? "-" : sumYards;
    } else {
      tableHeaderCellYds.textContent =
        y > 10 ? yardsArray[y - 2]?.yards : yardsArray[y - 1]?.yards;
    }

    tableHeaderYards.appendChild(tableHeaderCellYds);
  }

  const tableHeaderPar = createElement("tr");
  tableHeaderPar.classList.add("table-head-scroing");
  tableHeaderPar.setAttribute(
    "style",
    "background-color: var(--main-color-bg) !important"
  );

  tableBody.insertAdjacentElement("beforebegin", tableHeaderPar);

  for (let y = 0; y < columns; y++) {
    const tableHeaderCellPar = createElement("td");
    tableHeaderCellPar.classList.add("text-center");
    if (y === 0) {
      tableHeaderCellPar.textContent = "Par";
    } else if (y === 10) {
      const sumYards = sumYardsAndPar(yardsArray, "par", "out");
      tableHeaderCellPar.textContent = sumYards === 0 ? "-" : sumYards;
    } else if (y === 20) {
      const sumYards = sumYardsAndPar(yardsArray, "par", "in");
      tableHeaderCellPar.textContent = sumYards === 0 ? "-" : sumYards;
    } else if (y === 21) {
      const sumYards = sumYardsAndPar(yardsArray, "par", "tot");
      tableHeaderCellPar.textContent = sumYards === 0 ? "-" : sumYards;
    } else {
      tableHeaderCellPar.textContent =
        y > 10 ? yardsArray[y - 2]?.par : yardsArray[y - 1]?.par;
    }

    tableHeaderPar.appendChild(tableHeaderCellPar);
  }

  if (objectLength(rounds) > 0) {
    // create table body cells
    for (let x = 1; x < objectLength(rounds) + 1; x++) {
      const tableBodyRow = createElement("tr");
      // tableBodyRow.classList.add("row");
      tableBodyRow.classList.add("rounds-row");

      for (let i = 0; i < columns; i++) {
        // console.log(rounds[x]);
        const tableBodyCell = createElement("td");
        tableBodyCell.classList.add("col");
        tableBodyCell.classList.add("text-center");

        const scores = JSON.parse(rounds[x]?.scores);
        const sumYards = sumYardsAndPar(yardsArray, "par", "tot");

        if (i === 0) {
          tableBodyCell.textContent = `R${x}`;
          tableBodyCell.classList.add("rounds-scoring");
        } else if (i === 10) {
          const sumhole = sumHole(scores, "first");
          tableBodyCell.insertAdjacentHTML(
            "afterbegin",
            sumhole === 0 ? "" : sumhole
          );
        } else if (i === 20) {
          const sumhole = sumHole(scores, "last");
          tableBodyCell.insertAdjacentHTML(
            "afterbegin",
            sumhole === 0 ? "" : sumhole
          );
        } else if (i === 21) {
          const sumhole = sumHole(scores, "total");

          // compare tot par with tot RX (X - round number)
          // let sumTot = "";
          // if (sumYards > sumhole) {
          //   sumTot = scoreNumberHtmlElement("danger", sumhole);
          // } else if (sumYards < sumhole) {
          //   sumTot = scoreNumberHtmlElement("primary", sumhole);
          // } else {
          //   sumTot = sumhole;
          // }

          const sumTot = sumhole;

          tableBodyCell.insertAdjacentHTML(
            "afterbegin",
            sumhole === 0 ? "" : sumTot
          );

          // tableBodyCell.textContent = sumhole === 0 ? "" : sumhole;
        } else {
          tableBodyCell.insertAdjacentHTML(
            "afterbegin",
            numberInRound(scores, i > 10 ? i - 1 : i)
          );
        }

        // add cell to row
        tableBodyRow.appendChild(tableBodyCell);
      }
      tableBody.appendChild(tableBodyRow);
    }
  }

  // console.log(rowGlobal);

  return rowGlobal;
}

/**
 * Number in round
 *
 * @param {object} scores
 * @param {number} round
 */
function numberInRound(scores, number) {
  const parArray = yardsArray.map((arr) => arr.par);

  if (typeof scores === "undefined") return;

  const scoresNumber = Number(scores[number - 1]);
  const parNumber = parArray[number - 1];

  // console.log("parNumber", parNumber);
  // console.log("scoresNumber", scoresNumber);

  // if (scoresNumber === 0) {
  //   return "-";
  // } else if (scoresNumber === parNumber + 1) {
  //   // bogey
  //   return scoreNumberHtmlElementNew("bogey", "square", scoresNumber);
  // } else if (scoresNumber >= parNumber + 2) {
  //   // double bogey +
  //   return scoreNumberHtmlElementNew("double-bogey", "square", scoresNumber);
  // } else if (scoresNumber === parNumber - 1) {
  //   // Birdie
  //   return scoreNumberHtmlElementNew("birdie", "circle", scoresNumber);
  // } else if (scoresNumber <= parNumber - 2) {
  //   // eagle or better
  //   return scoreNumberHtmlElementNew("eagle", "circle", scoresNumber);
  // } else if (scoresNumber === parNumber) {
  //   return scoresNumber;
  // } else {
  //   return "-";
  // }

  if (parNumber > scoresNumber) {
    return scoresNumber === 0
      ? "-"
      : scoreNumberHtmlElement("danger", scoresNumber);
  } else if (parNumber < scoresNumber) {
    return scoresNumber === 0
      ? "-"
      : scoreNumberHtmlElement("primary", scoresNumber);
  } else {
    return scoresNumber;
  }
}

/**
 * Sum hole score
 *
 * @param {array} scores
 * @param {string} holes
 * @returns {number}
 */
function sumHole(scores, holes) {
  const parOUT = yardsArray
    .map((arr) => arr.par)
    .slice(0, 9)
    .reduce((a, b) => Number(a) + Number(b), 0);

  const parIN = yardsArray
    .map((arr) => arr.par)
    .slice(9, 18)
    .reduce((a, b) => Number(a) + Number(b), 0);

  let holesNumber;

  if (holes === "first") {
    holesNumber = scores.slice(0, 9).reduce((a, b) => Number(a) + Number(b), 0);
  }
  if (holes === "last") {
    holesNumber = scores
      .slice(9, 18)
      .reduce((a, b) => Number(a) + Number(b), 0);
  }
  if (holes === "total") {
    holesNumber = scores.reduce((a, b) => Number(a) + Number(b), 0);
  }

  const holesNumberCheck = holesNumber === 0 ? "-" : holesNumber;

  if (holes === "first") {
    if (parOUT > holesNumber) {
      return scoreNumberHtmlElement("danger", holesNumberCheck);
    } else if (parOUT < holesNumber) {
      return scoreNumberHtmlElement("primary", holesNumberCheck);
    } else {
      return holesNumberCheck;
    }
  }

  if (holes === "last") {
    if (parIN > holesNumber) {
      return scoreNumberHtmlElement("danger", holesNumberCheck);
    } else if (parIN < holesNumber) {
      return scoreNumberHtmlElement("primary", holesNumberCheck);
    } else {
      return holesNumberCheck;
    }
  }

  return holesNumberCheck;
}

/**
 * Legend for leaderboard added after tbody
 */
const legendForLeaderBoard = `
    <tfoot class="scoring-table-footer">
      <tr>
        <td colspan="100%">
          <div class="d-flex legend-table">
            <div class="legend-element legend-eagle">
              <div class="legend-icon icon-circle icon-eagle"></div>
              <div class="legend-text">Eagle or Better</div>
            </div>
            <div class="legend-element legend-birdie">
              <div class="legend-icon icon-circle icon-birdie"></div>
              <div class="legend-text">Birdie</div>
            </div>
            <div class="legend-element legend-bogey">
              <div class="legend-icon icon-square icon-bogey"></div>
              <div class="legend-text">Bogey</div>
            </div>
            <div class="legend-element legend-double-bogey">
              <div class="legend-icon icon-square icon-double-bogey"></div>
              <div class="legend-text">Double Bogey +</div>
            </div>
          </div>
        </td>
      </tr>
    </tfoot>
  `;

/**
 * Sum Yards and Par
 *
 * @param {array} array
 * @param {string} type
 * @param {string} where
 * @returns {number}
 */
function sumYardsAndPar(array, type, where) {
  const yardsOrParArray = array.map((arr) => {
    return type === "yds" ? arr.yards : arr.par;
  });
  if (where === "out") {
    return yardsOrParArray.slice(0, 9).reduce((a, b) => a + b, 0);
  }
  if (where === "in") {
    return yardsOrParArray.slice(9, 18).reduce((a, b) => a + b, 0);
  }
  if (where === "tot") {
    return yardsOrParArray.reduce((a, b) => a + b, 0);
  }
}

/**
 * set visible row in local storage
 */
export default function UpdatePlayersScoring() {
  const getLocalStoragePlayers = getItemLocalStorage("HQshowScoringPlayer");
  if (getLocalStoragePlayers && getLocalStoragePlayers?.length > 0) {
    getLocalStoragePlayers.map((playerId) => {
      FindPlayerData(playerId, "players");
    });
  }

  const getLocalStorageFavorites = getItemLocalStorage("HQshowFavoritesPlayer");
  if (getLocalStorageFavorites && getLocalStorageFavorites?.length > 0) {
    getLocalStorageFavorites.map((playerId) => {
      FindPlayerData(playerId, "favorites");
    });
  }
}
